import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_DOCUMENT_REQUEST, CREATING_DOCUMENT_REQUEST, DOCUMENT_REQUESTS_ERROR, GETTING_DOCUMENT_REQUESTS, GET_DOCUMENT_REQUESTS, UPDATE_DOCUMENT_REQUEST, UPDATING_DOCUMENT_REQUEST } from "../types"

export const createDocumentRequest = (documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_DOCUMENT_REQUEST,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/document-requests`, documentRequestPayload, { headers })
        
        dispatch({
            type: CREATE_DOCUMENT_REQUEST,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: DOCUMENT_REQUESTS_ERROR,
            error
        })
    }
}

export const fetchDocumentRequests = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/document-requests?expand=student,application,requestedBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_DOCUMENT_REQUESTS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_DOCUMENT_REQUESTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: DOCUMENT_REQUESTS_ERROR,
            error
        })
    }
}

export const updateDocumentRequest = (id, documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_DOCUMENT_REQUEST,
            payload: id
        })

        const response = await axios.patch(`${baseUrl}/document-requests/${id}`, documentRequestPayload, { headers })
        
        dispatch({
            type: UPDATE_DOCUMENT_REQUEST,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: DOCUMENT_REQUESTS_ERROR,
            error
        })
    }
}

export const clearCreatedDocumentRequest = () => async (dispatch) => {    
    dispatch({
        type: CREATE_DOCUMENT_REQUEST,
        payload: null
    })
}

export const clearUpdatedDocumentRequest = () => async (dispatch) => {    
    dispatch({
        type: CREATE_DOCUMENT_REQUEST,
        payload: null
    })
}